<template>
  <page-layout
    :header="isMobile"
    :loaded="currentUserLoaded"
    class="home-page"
    title="Home"
  >
    <div class="content-main">
      <div class="content-main__centered">
        <h4 class="appMain--text mb-2">Hello {{ userName }}!</h4>
        <p class="mb-4">
          <template v-if="currentUser">
            Welcome to your ConveYour dashboard, here is a brief overview of
            your account.
          </template>
          <template v-else> Welcome to ConveYour dashboard. </template>
        </p>

        <home-progress-bar />

        <template v-if="currentUser">
          <home-stats />

          <home-search />

          <home-onboarding-status />
        </template>

        <home-updates class="mt-8" />
      </div>
    </div>
  </page-layout>
</template>

<script>
import { mapGetters } from 'vuex';

import HomeProgressBar from './HomeProgressBar.vue';
import HomeStats from './HomeStats';
import HomeSearch from './HomeSearch.vue';
import HomeOnboardingStatus from './HomeOnboardingStatus.vue';
import HomeUpdates from './HomeUpdates';

export default {
  name: 'HomeView',
  components: {
    HomeProgressBar,
    HomeStats,
    HomeSearch,
    HomeOnboardingStatus,
    HomeUpdates,
  },
  computed: {
    userName() {
      return this.currentUser?.first_name || '';
    },
    ...mapGetters('users', ['currentUser', 'currentUserLoaded', 'isAdmin']),
  },
};
</script>

<style lang="less">
.home-page {
  .field-block + .field-block {
    margin-top: 42px;
  }

  .item-card:not(.link-card) {
    background-color: #fff;
    cursor: default;

    &:hover {
      box-shadow: @content-shadow;
      background-color: #fff;

      .content-line,
      .item-card__content {
        background-color: #fff;
      }
    }
  }

  .item-card__content {
    .content-list {
      margin-top: -8px;
    }
  }

  a:hover {
    text-decoration: none;
  }
}
</style>
